export default __webpack_public_path__ + "static/media/Arca of Jaggta-Noga.f4a58cc8.jpg";